import Vuex        from 'vuex'
import sessionData from '@/store/modules/sessionData'

export default new Vuex.Store({
    modules: {
        sessionData
    }
})